export const TERMS_AND_CONDITIONS_PAGE = 'termsAndConditions';
export const PRIVACY_POLICY_PAGE = 'privacyPolicy';
export const SCROLL_TO_MOVE = 40;
